export enum DateFilterVariant {
  dueDate = 'dueDate',
  surgeryDate = 'surgeryDate',
}
